module.exports = __webpack_public_path__ + "img/pdf.12f213ad.png";